export default "__VITE_ASSET__s54lldst__"